import { databaseTableNames } from 'utils/consts/routes/database'

export const databaseFiltersName = {
  countryFilter: 'countryFilter',
  countryFilter2: 'countryFilter2',
  usersFilter: 'usersFilter',
  sourceFilter: 'sourceFilter',
  creationDateFilter: 'creationDateFilter',
  lastUpdateFilter: 'lastUpdateFilter',
  checkedByFilter: 'checkedByFilter',
  invalidRecordFilter: 'invalidRecordFilter',
  registrationFilter: 'registrationFilter',
  producerFilter: 'producerFilter',
  producerWWLFilter: 'producerWWLFilter',
  euGITypeFilter: 'euGITypeFilter',
  nationalGITypeFilter: 'nationalGITypeFilter',
  wineRegionEUFilter: 'wineRegionEUFilter',
  geoIndicationFilter: 'geoIndicationFilter',
  wineTypeFilter: 'wineTypeFilter',
  wineColourFilter: 'wineColourFilter',
  sweetnessTypeFilter: 'sweetnessTypeFilter',
  vintageFilter: 'vintageFilter',
  bottleSizeFilter: 'bottleSizeFilter',
  packageTypeFilter: 'packageTypeFilter',
  grapesFilter: 'grapesFilter',
  certificatesFilter: 'certificatesFilter',
  alcoholLevelFilter: 'alcoholLevelFilter',
  cellarDoorPriceFilter: 'cellarDoorPriceFilter',
  wwlRatingFilter: 'wwlRatingFilter',
  brandFilter: 'brandFilter',
  monocepageFilter: 'monocepageFilter',
  legalEntityFilter: 'legalEntityFilter',
  synonymsFilter: 'synonymsFilter',
  havePublicReviewsFilter: 'havePublicReviewsFilter',
  specialClassificationFilter: 'specialClassificationFilter',
  parentGeoIndicationFilter: 'parentGeoIndicationFilter',
  wineTerritoryTypeFilter: 'wineTerritoryTypeFilter',
  dateStartFilter: 'dateStartFilter',
  dateEndFilter: 'dateEndFilter',
  participantsFilter: 'participantsFilter',
  exhibitionTypeFilter: 'exhibitionTypeFilter',
  retailPriceFilter: 'retailPriceFilter',
  hasVerifiedRepresentativeFilter: 'hasVerifiedRepresentativeFilter',
  hasWebsiteFilter: 'hasWebsiteFilter',
  hasEmailFilter: 'hasEmailFilter',
  hasPhoneFilter: 'hasPhoneFilter',
  onlyLatestVintageFilter: 'onlyLatestVintageFilter',
  hasBottleImageFilter: 'hasBottleImageFilter',
  hasFrontLabelImageFilter: 'hasFrontLabelImageFilter',
  hasBackLabelImageFilter: 'hasBackLabelImageFilter',
  adminPackshotImageFilter: 'adminPackshotImageFilter',
  adminFrontLabelImageFilter: 'adminFrontLabelImageFilter',
  adminBackLabelImageFilter: 'adminBackLabelImageFilter',
  additionalNameFilter: 'additionalNameFilter',
  withAdditionalNameFilter: 'withAdditionalNameFilter',
}
export const databaseFiltersTitle = {
  countryFilter: 'filters.names.country',
  usersFilter: 'filters.names.users',
  sourceFilter: 'filters.names.source',
  creationDateFilter: 'filters.names.creationDate',
  lastUpdateFilter: 'filters.names.lastUpdate',
  checkedByFilter: 'filters.names.checkedBy',
  invalidRecordFilter: 'filters.names.invalidRecord',
  registrationFilter: 'filters.names.registration',
  producerFilter: 'filters.names.producer',
  producerWWLFilter: 'filters.names.producerWWLFilter',
  euGITypeFilter: 'filters.names.euGITypeFilter',
  nationalGITypeFilter: 'filters.names.nationalGITypeFilter',
  wineRegionEUFilter: 'filters.names.wineRegionEUFilter',
  geoIndicationFilter: 'filters.names.geoIndicationFilter',
  wineTypeFilter: 'filters.names.wineTypeFilter',
  wineColourFilter: 'filters.names.wineColourFilter',
  sweetnessTypeFilter: 'filters.names.sweetnessTypeFilter',
  vintageFilter: 'filters.names.vintageFilter',
  bottleSizeFilter: 'filters.names.bottleSizeFilter',
  packageTypeFilter: 'filters.names.packageTypeFilter',
  grapesFilter: 'filters.names.grapesFilter',
  certificatesFilter: 'filters.names.certificatesFilter',
  alcoholLevelFilter: 'filters.names.alcoholLevelFilter',
  cellarDoorPriceFilter: 'filters.names.recommendedRetailPriceFilter',
  wwlRatingFilter: 'filters.names.wwlRatingFilter',
  brandFilter: 'filters.names.brandFilter',
  monocepageFilter: 'filters.names.monocepageFilter',
  legalEntityFilter: 'filters.names.legalEntityFilter',
  synonymsFilter: 'filters.names.synonymsFilter',
  havePublicReviewsFilter: 'filters.names.havePublicReviewsFilters',
  hasReviews: 'filters.names.hasReviews',
  specialClassificationFilter: 'filters.names.specialClassificationFilter',
  parentGeoIndicationFilter: 'filters.names.parentGeoIndicationFilter',
  wineTerritoryTypeFilter: 'filters.names.wineTerritoryTypeFilter',
  dateStartFilter: 'filters.names.startDateFilter',
  dateEndFilter: 'filters.names.endDateFilter',
  participantsFilter: 'filters.names.participantsFilter',
  exhibitionTypeFilter: 'filters.names.exhibitionTypeFilter',
  retailPriceFilter: 'filters.names.retailPrice',
  hasVerifiedRepresentativeFilter: 'filters.names.hasVerifiedRepresentative',
  hasWebsiteFilter: 'filters.names.website',
  hasEmailFilter: 'filters.names.email',
  hasPhoneFilter: 'filters.names.phone',
  onlyLatestVintageFilter: 'filters.names.onlyLatestVintage',
  hasBottleImageFilter: 'filters.names.packshot',
  hasFrontLabelImageFilter: 'filters.names.frontLabel',
  hasBackLabelImageFilter: 'filters.names.backLabel',
  adminPackshotImageFilter: 'filters.names.adminPackshot',
  adminFrontLabelImageFilter: 'filters.names.adminFrontLabel',
  adminBackLabelImageFilter: 'filters.names.adminBackLabel',
  additionalNameFilter: 'filters.names.additionalName',
  withAdditionalNameFilter: 'filters.names.withAdditionalName',
}
export const databaseFiltersKey = () => {
  const currentPage = window.location.pathname.split('/')[3]
  const countryFilter = {
    [databaseTableNames.producers]: 'country',
    [databaseTableNames.producersDuplicates]: 'country',
    [databaseTableNames.brands]: 'tradeNameCountry',
    [databaseTableNames.wines]: 'country',
    [databaseTableNames.geoIndication]: 'country',
    default: 'country',
  }

  const wwlRatingFilter = {
    [databaseTableNames.producers]: 'wines.rating',
    [databaseTableNames.producersDuplicates]: 'wines.rating',
    [databaseTableNames.wines]: 'rating',
    default: 'wines.rating',
  }

  const specialClassificationFilter = {
    [databaseTableNames.producers]: 'wines.specialClassification',
    [databaseTableNames.producersDuplicates]: 'wines.specialClassification',
    [databaseTableNames.wines]: 'specialClassification',
    [databaseTableNames.specialClassificationCondition]:
      'specialClassification',
    default: 'specialClassification',
  }

  return {
    countryFilter: countryFilter[currentPage] ?? countryFilter.default,
    usersFilter: 'updateUserUsername',
    sourceFilter: 'source',
    creationDateFilter: 'createdAt',
    lastUpdateFilter: 'updatedAt',
    checkedByFilter: 'checkedBy',
    invalidRecordFilter: 'invalidRecord',
    registrationFilter: 'hasRegistration',
    producerFilter: 'tradeName',
    producerWWLFilter: 'hasVerifiedRepresentative',
    euGITypeFilter: 'euGIType',
    nationalGITypeFilter: 'nationalGIType',
    wineRegionEUFilter: 'wineRegionEU',
    geoIndicationFilter: 'geoIndication',
    wineTypeFilter: 'wineType',
    wineColourFilter: 'wineColor',
    sweetnessTypeFilter: 'sweetnessLevel',
    vintageFilter: 'vintage',
    bottleSizeFilter: 'bottleSize',
    packageTypeFilter: 'packageType',
    grapesFilter: 'grapeAndMonocepage',
    certificatesFilter: 'certification',
    alcoholLevelFilter: 'alcoholOnLabel',
    cellarDoorPriceFilter: 'cellarDoorPrice',
    wwlRatingFilter: wwlRatingFilter[currentPage] ?? wwlRatingFilter.default,
    brandFilter: 'brand',
    monocepageFilter: 'grapeAndMonocepage.monocepage',
    legalEntityFilter: 'hasLegalEntity',
    synonymsFilter: 'includeSynonyms',
    havePublicReviewsFilter: 'havePublicReviewsBool',
    parentGeoIndicationFilter: 'parent',
    wineTerritoryTypeFilter: 'wineTerritoryType',
    specialClassificationFilter:
      specialClassificationFilter[currentPage] ??
      specialClassificationFilter.default,
    dateStartFilter: 'dateStart',
    dateEndFilter: 'dateEnd',
    participantsFilter: 'participants',
    exhibitionTypeFilter: 'exhibitionType',
    retailPriceFilter: 'tradeOfferLotPricePerBottle',
    hasVerifiedRepresentativeFilter: 'hasVerifiedRepresentative',
    hasWebsiteFilter: 'hasWebsite',
    hasEmailFilter: 'hasEmail',
    hasPhoneFilter: 'hasPhone',
    onlyLatestVintageFilter: 'onlyLatestVintage',
    hasBottleImageFilter: 'hasBottleImage',
    hasFrontLabelImageFilter: 'hasFrontLabelImage',
    hasBackLabelImageFilter: 'hasBackLabelImage',
    adminPackshotImageFilter: 'hasPrivateBottleImage',
    adminFrontLabelImageFilter: 'hasPrivateFrontLabelImage',
    adminBackLabelImageFilter: 'hasPrivateBackLabelImage',
    additionalNameFilter: 'keywords',
    withAdditionalNameFilter: 'keywordsExists',
  }
}
